<!-- 用户中心 -->
<template>
    <div>
        <admin-main-header>
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ name: 'Forward', params: {target: 'Index'} }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>操作日志</el-breadcrumb-item>
            </el-breadcrumb>
        </admin-main-header>

        <div class="admin-main-body">
            <div class="admin-content" :style="{minHeight: adminContentMinHeight + 'px'}">
                <div class="admin-content-title el-clearfix">
                    <span class="el-title-bar"> 操作日志</span>
                </div>
                <div class="admin-content-main">
                    <el-form ref="userAccessLogQueryForm" :model="userAccessLogQueryForm" style="padding: 5px 0 0;">
                        <el-row :gutter="20">
                            <el-col :span="4" :offset="2">
                                <el-form-item prop="logTitle">
                                    <el-input v-model="userAccessLogQueryForm.logTitle" :maxlength="100" placeholder="日志标题"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="11">
                                <el-form-item class="el-inline-block el-align-right" prop="startAccessTime" style="width:40%;">
                                    <el-date-picker v-model="userAccessLogQueryForm.startAccessTime" clearable type="datetime" placeholder="访问时间(开始)" value-format="yyyy-MM-ddTHH:mm:ss.SSSZ"></el-date-picker>
                                </el-form-item>
                                <span class="el-inline-block" style="width:10%;text-align:center;line-height:32px;vertical-align:top;"> ~ </span>
                                <el-form-item class="el-inline-block el-align-left" prop="endAccessTime" style="width:40%;">
                                    <el-date-picker v-model="userAccessLogQueryForm.endAccessTime" clearable type="datetime" placeholder="访问时间(结束)" value-format="yyyy-MM-ddTHH:mm:ss.SSSZ"></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5">
                                <el-form-item class="el-align-center">
                                    <el-button @click="resetUserAccessLogQueryForm" icon="fas fa-undo">重 置</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
                                    <el-button type="primary" @click="queryUserAccessLogList(1000)" icon="fas fa-search">查 询</el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                    <el-table ref="userAccessLogTable" v-loading="userAccessLogLoading" class="el-table-overflow-x-hidden" element-loading-text="拼命加载中..." element-loading-custom-class="el-loading-mask-opacity" :class="{loading: userAccessLogLoading}" :data="userAccessLogList" :default-sort="userAccessLogQuerySort" @sort-change="onUserAccessLogQuerySortChange" style="width:100%;" empty-text="暂无数据">
                        <el-table-column label="#" type="index" width="40"></el-table-column>
                        <el-table-column label="功能模块" prop="appModule" width="100" sortable></el-table-column>
                        <el-table-column label="日志标题" prop="logTitle" width="180" sortable></el-table-column>
                        <el-table-column label="请求URI" prop="requestUri" sortable></el-table-column>
                        <el-table-column label="请求方法" prop="httpMethod" width="100" sortable></el-table-column>
                        <el-table-column label="客户端IP" prop="clientIpAddr" width="100" align="center" sortable></el-table-column>
                        <el-table-column label="服务端IP" prop="serverIpAddr" width="160" align="center" sortable></el-table-column>
                        <el-table-column label="访问耗时" prop="processTime" width="100" align="center" :formatter="formatProcessTime" sortable></el-table-column>
                        <el-table-column label="访问时间" prop="accessTime" width="100" align="center" sortable></el-table-column>
                    </el-table>
                    <div class="el-search-pager">
                        <el-pagination background v-show="showAccessLogQueryPager" @current-change="onUserAccessLogQueryCurrentPageChange" :current-page.sync="userAccessLogQueryForm.currentPage" :page-size="userAccessLogQueryForm.pageSize" layout="slot, prev, pager, next, total" :total="userAccessLogQueryTotal">
                            <div class="el-pagination-pagesize">
                                <span class="first">每页显示</span>
                                <el-button-group>
                                    <el-button :class="{active: userAccessLogQueryForm.pageSize == 10}" @click="onUserAccessLogQueryPageSizeChange(10);">10</el-button>
                                    <el-button :class="{active: userAccessLogQueryForm.pageSize == 20}" @click="onUserAccessLogQueryPageSizeChange(20);">20</el-button>
                                    <el-button :class="{active: userAccessLogQueryForm.pageSize == 50}" @click="onUserAccessLogQueryPageSizeChange(50);">50</el-button>
                                    <el-button :class="{active: userAccessLogQueryForm.pageSize == 100}" @click="onUserAccessLogQueryPageSizeChange(100);">100</el-button>
                                </el-button-group>
                                <span class="last">条</span>
                            </div>
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defaultApiErrorHandler, PLATFORM_API } from '@/api.js';
import { mapSort } from '@/utils.js';

export default {
    name: 'UpmsUserCenter',
    data() {
        return {
            submiting: false,
            userAccessLogList: [],
            userAccessLogQuering: false,
            userAccessLogQueryForm: {
                logTitle: '',
                accessUserId: '',
                startAccessTime: '',
                endAccessTime: '',
                pageSize: 10,
                currentPage: 1
            },
            userAccessLogQuerySort: {
                prop: 'accessTime',
                order: 'descending'
            },
            userAccessLogQueryTotal: 0,
            userAccessLogLoading: false
        };
    },
    computed: {
        showAccessLogQueryPager() {
            if (
                this.userAccessLogQuering ||
                this.userAccessLogQueryTotal == 0
            ) {
                return false;
            } else {
                return true;
            }
        }
    },
    created() {},
    mounted() {
        this.queryUserAccessLogList(1000);
    },
    methods: {
        formatProcessTime(row, column) {
            return row.processTime + '毫秒';
        },
        queryUserAccessLogList(loading) {
            this.userAccessLogQueryForm.currentPage = 1;
            this.doQueryUserAccessLogList(loading);
        },
        doQueryUserAccessLogList(loading) {
            this.userAccessLogQuering = true;
            if (loading) {
                this.userAccessLogLoading = true;
            }
            setTimeout(() => {
                let params = Object.assign(
                    {},
                    this.userAccessLogQueryForm,
                    mapSort(this.userAccessLogQuerySort)
                );
                this.$http
                    .get(
                        PLATFORM_API.of(
                            '/api/platform/login/user/accesslog/list'
                        ),
                        {
                            params: params
                        }
                    )
                    .then(response => {
                        let result = response.data;
                        if (result.success) {
                            this.userAccessLogList = result.data;
                            this.userAccessLogQueryTotal = result.totalRowCount;
                        } else {
                            this.userAccessLogList = [];
                            this.userAccessLogQueryTotal = 0;
                            this.$message.error(result.message);
                        }
                    })
                    .catch(error => {
                        this.userAccessLogList = [];
                        this.userAccessLogQueryTotal = 0;
                        defaultApiErrorHandler.call(this, error);
                    })
                    .then(() => {
                        if (loading) {
                            this.userAccessLogLoading = false;
                        }
                        this.userAccessLogQuering = false;
                    });
            }, loading);
        },
        resetUserAccessLogQueryForm() {
            this.$refs.userAccessLogQueryForm.resetFields();
        },
        onUserAccessLogQuerySortChange(parameter) {
            if (
                this.userAccessLogQuerySort.prop != parameter.prop ||
                this.userAccessLogQuerySort.order != parameter.order
            ) {
                this.userAccessLogQuerySort.prop = parameter.prop;
                this.userAccessLogQuerySort.order = parameter.order;
                this.queryUserAccessLogList(1000);
            }
        },
        onUserAccessLogQueryCurrentPageChange(currentPage) {
            this.userAccessLogQueryForm.currentPage = currentPage;
            this.doQueryUserAccessLogList(1000);
        },
        onUserAccessLogQueryPageSizeChange(pageSize) {
            this.userAccessLogQueryForm.pageSize = pageSize;
            this.queryUserAccessLogList(1000);
        }
    }
};
</script>

<style lang="scss">
</style>